import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classnames from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';
import langIsEn from '../../utils/langIsEn';
import styles from './ProjectFullRow.css';

class ProjectFullRow extends Component {
  static propTypes = {
    project: PropTypes.object,
    picUrlAttr: PropTypes.string.isRequired,
  };

  state = {
    isVisible: false,
  }

  onChange(isVisible) {
    if (!this.state.isVisible && isVisible) {
      this.setState({
        isVisible: isVisible,
      });
    }
  }

  render() {
    const { project, picUrlAttr } = this.props;
    const { isVisible } = this.state;

    return (
      <div className={styles.project}>
        <Link to={`/projects/${project.engName}`}>
          <div className={styles.img}>
            <VisibilitySensor
              onChange={this.onChange.bind(this)}
              partialVisibility={true}
            >
              <img
                className={classnames(styles.content, { 'animated fadeInUp': isVisible })}
                src={project[picUrlAttr]}
                alt={project.engName}
              />
            </VisibilitySensor>
          </div>
          <p className={styles.tags}>{project.tags.join(', ')}</p>
          <p className={styles.name}>
            <span className={styles.engName}>{project.engName}</span>
            {!langIsEn() && project.chtName && <span className={styles.chtName}>{project.chtName}</span>}
          </p>
        </Link>
      </div>
    );
  }
}

export default ProjectFullRow;



// WEBPACK FOOTER //
// ./src/components/project-full-row/ProjectFullRow.js